import React, { useEffect, useState } from 'react';
import { Balloon, NumberPicker, Select } from '@alifd/next';
import styles from './index.module.scss';

// 规定出所有可能的选择类型
const sectionType = [
  {
    label: '区间',
    key: 'RANGE',
  },
  {
    label: '大于等于',
    key: 'RANGEGT',
  },
  {
    label: '小于等于',
    key: 'RANGELT',
  },
];

/**
 * opType 在dayType数组范围内
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 * tagItem.value[0].type: 数量1  金额2~需要乘100传值，前端展示元，后端计算分  可输入负数3~积分余额都可输负数 金额但不需要转换单位4~大概只为了给云鹿的陆泽标签人群用 可以输入小数5~
 */
const TagSection = ({
  tagItem = {},
  changeData = (data) => { },
  pageType = ''
}) => {
  const [type, setType] = useState(tagItem.opType ? tagItem.opType : 'RANGE'); // 枚举类型见dayType
  const [data, setData] = useState(tagItem.opType === 'RANGE' ? [tagItem.opValue?.extra_map?.[0]?? '', tagItem.opValue?.extra_map?.[1] ?? ''] : [0, tagItem.opValue?.extra_map?.[0]?? '']); // 区间的值更改前或后面的值适合用数组形式改变，所以自己内部维护一个数组
  const isCustomized = new Map([
    ['2113', {placeholder:'填写金额/元',min:1, max:999999999}],
    ['2123', {placeholder:'填写金额/元',min:1, max:999999999}],
    ['2133', {placeholder:'填写数量/件',min:1, max:99999999}],
    ['2143', {placeholder:'填写数量/件',min:1, max:99999999}]
  ]) //有特殊提示语最大值最小值的
  const handleData = (d1 = '', d2 = '', currentType) => {
    const extra_map = currentType === 'RANGE' ? [
      +d1,+d2
     ] : [+d2]
    return {
      label_id: tagItem?.id,
      extra_map
    }
  }

  /**
   * @description: 改变传递的区间类型
   * @param {*} val
   * @return {*}
   */
  const changeType = (val) => {
    setType(val);
    if (val === 'RANGE') {
      setData(['', '']);
      changeData({ opValue: handleData('', '',val), opType: val, opDescValue: '区间' }); // opDescValue拿到所选择的所有值的中文释义
    } else if (val === 'RANGEGT') {
      setData(['0', '']);
      changeData({ opValue: handleData('','',val), opType: val, opDescValue: '大于等于' });
    } else {
      // 小于等于，下限为0
      setData(['0', '']);
      changeData({ opValue: handleData('','',val), opType: val, opDescValue: '小于等于' });
    }
  };

  /**
   * 选择时改变也要处理成数组形式
   */
  const changeValue = ({ opValue, index, defaultType }) => {
    let newType = defaultType ? defaultType : type;
    let opDescValue =
    newType === 'RANGE' ? '区间' : newType === 'RANGEGT' ? '大于等于' : '小于等于';
    if (opValue !== '' && opValue !== undefined) {
      // 执行删除操作时，传过来的值会是 undefined
      const arr = [...data];
      const temp = opValue.toString();
      arr[index] = temp;
      const opDescArr = arr;
      opDescValue = newType === 'RANGE' ? `${opDescValue}${opDescArr}` : `${opDescValue}${opValue}`
      setData(arr);
      changeData({
        opValue: handleData(arr[0], arr[1],newType),
        opType: newType,
        opDescValue: opDescValue,
        checkContent: true,
      });
    } else if (!opValue) {
      const arr = [...data];
      arr[index] = '';
      setData(arr);
      changeData({
        opValue: handleData(arr[0], arr[1],newType),
        opType: newType,
        opDescValue: opDescValue,
        checkContent: true,
      });
    }
  };

  /**
   * @description: 针对数量和金额的不同类型，需要对值做倍数的不同处理，如果是金额，需要把输入时乘的100倍再除回去
   * @param {*} val
   * @return {*}
   */
  const returnVal = (val) => {
    return Number(val);
  };

  const numMax = 999999999; // 数字类型的最大区间
  useEffect(()=>{
    if( pageType==='1' || (pageType ==='2' && !tagItem.opValue)) { // 如果是创建
      if(tagItem.id === '2113' || tagItem.id === '2123' || tagItem.id === '2133' || tagItem.id === '2143') { 
        // 如果为[新客人群客单价-客单价] || [老客人群客单价-客单价] || [近期在直播间下单sku-商品件数] || [近期在短视频内下单sku-商品件数] 
        changeType('RANGEGT');
        changeValue({ opValue:1, index: 1, defaultType:'RANGEGT' })
      }
    }
  },[pageType])
  return (
    <div className={`${styles['tag-section']} ${styles['tag-width']}`}>
      <div className={styles['titleBox']}>
        <div style={{color:'#ff3333'}}>*</div>
        <div>
          {tagItem.labelName}
          { tagItem.labelDescription &&
            <Balloon.Tooltip
              align="t"
              closable={false}
              trigger={
                <span
                  style={{
                    fontSize: '16px',
                    marginLeft: '4px',
                    cursor: 'pointer',
                  }}
                  className="iconfont icon-icon4-33"
                />
              }
            >
              <div>
                {tagItem.labelDescription}
              </div>
            </Balloon.Tooltip>
          }
        </div>
        :
        <Select
          followTrigger
          value={type}
          onChange={(val) => changeType(val)}
          className="tag-type-select"
        >
          {sectionType.map((its, ins) => (
            <Select.Option key={`${its.label}${ins}`} value={its.key}>
              {its.label}
            </Select.Option>
          ))}
        </Select>
        {type === 'RANGE' ? (
          <>
            <NumberPicker
              placeholder={isCustomized.has(tagItem.id) ? (isCustomized.get(tagItem.id)?.placeholder) : ''}
              min={isCustomized.has(tagItem.id) ? (isCustomized.get(tagItem.id)?.min) : 0}
              max={isCustomized.has(tagItem.id) ? (isCustomized.get(tagItem.id)?.max) : numMax}
              style={{width:'150px'}}
              precision={0}
              value={data[0] ? returnVal(data[0]) : null}
              onChange={(opValue) => changeValue({ opValue, index: 0 })}
            />
            <span> - </span>
            <NumberPicker
              placeholder={isCustomized.has(tagItem.id) ? (isCustomized.get(tagItem.id)?.placeholder) : ''}
              min={isCustomized.has(tagItem.id) ? (isCustomized.get(tagItem.id)?.min) : 0}
              max={isCustomized.has(tagItem.id) ? (isCustomized.get(tagItem.id)?.max) : numMax}
              precision={0}
              style={{width:'150px'}}
              value={data[1] ? returnVal(data[1]) : null}
              onChange={(opValue) => changeValue({ opValue, index: 1 })}
            />
          </>
        ) : (
          <NumberPicker
            placeholder={isCustomized.has(tagItem.id) ? (isCustomized.get(tagItem.id)?.placeholder) : ''}
            min={isCustomized.has(tagItem.id) ? (isCustomized.get(tagItem.id)?.min) : 0}
            max={isCustomized.has(tagItem.id) ? (isCustomized.get(tagItem.id)?.max) : numMax}
            precision={0}
            style={{width:'150px'}}
            value={data[1] ? returnVal(data[1]) : null}
            onChange={(opValue) => changeValue({ opValue, index: 1 })}
          />
        )}
      </div>
      { !(type === 'RANGE' ? data.every((item) => +item > 0) : +data[1] > 0 ) && (
          <div style={{ color: "#f33" }}
            className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
          >
            请输入{tagItem.labelName}
          </div>
        )}
    </div>
  );
};
export default TagSection;
